<template>
  <div class="byline">
    <sc-text tag="p" :field="byLine" :encode="false" />
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-ResourceByLine',
  props: {
    byLine: {
      type: Object
    }
  },
  components: {
    ScText: Text
  }
};
</script>
<style lang="scss">
.byline {
  p {
    font-weight: 500;
  }
}
</style>
